import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import About from "./components/About";
import Header from "./components/Header";
import HomePage from "./components/HomePage";
import Login from "./Login";
import Groups from "./components/Groups";
import Calendar from "./components/Calendar";
import MonthAtAGlance from "./components/MonthCal";
import OurBranch from "./components/OurBranch";
import TeachingMethod from "./components/TeachingMethod";
import InteractiveGallery from "./components/Gallery";
import BlogsAndNews from "./components/Blogs";
import BlogDetail from "./components/BlogDetail";
import StudentProfile from "./components/ProfileDetail";
import Dashboard from "./components/Dashboard";
import CurricumOfLove from "./components/CurricumOfLove";
import GetInTouch from "./components/GetInTouchPage";
import Faq from "./components/Faq";
import MyGallery from "./components/MyGallery";
import Privacy from "./components/Privacy";
import TermsConditions from "./components/TermsConditions";
import useProfile from "./customHooks/useProfile";
import chatIcon from "./assets/chatIcon.svg";
import Admission from "./components/Admission";
import PositiveParenting from "./components/PositiveParenting";
import ParticularGroup from "./components/ParticularGroup";
import Programs from "./components/Programs";
import Facilities from "./components/Facilities";
import Celebration from "./components/Celebration";
import Events from "./components/Events";
import Dignitories from "./components/Dignitories";
import Activities from "./components/Activities";
import ThoughtLeadership from "./components/ThoughtLeadership";
import ParentingTips from "./components/ParentingTips";
import PreLoadingImages from "./components/custom/PreLoadingImages";
import NotFound from "./components/NotFound";
import { homePageImages , pageRedirects } from "./utils/constants";
import { Provider } from "react-redux";
import { store } from "./redux/store";
// import ManagementTeam from "./components/ManagementTeam";

function App() {
  const location = useLocation(); // Get the current location

  // Determine the background color based on the current path
  const path=location.pathname;
  const bgColor =
    path === "/" ||
    path === "/monthcal" ||
    path === "/teachingmethod"
      ? "#fff3ed"
      : path === "/about" ||
        path === "/branch" ||
        path === "/admission" ||
        path === "/thoughtLeadership"
      ? "#e0faff"
      : path === "/groups"
      ? "#ffffff" 
      : "#fff3ed";

  const { token } = useProfile();

  function PrivateRoute({ children }) {
    if (token !== null) {
      return children;
    } else {
      return <Navigate to="/login" />;
    }
  }

  function RedirectionRouter({ children }) {
    if (path === "/momandi.php") {
      window.open("https://momandi.in/", "_self", "noreferrer");
      return;
    }
    const currentPath = pageRedirects?.find(
      (item) => item.path === path
    );
    if (currentPath) {
      return <Navigate to={currentPath?.redirectedPath} />;
    } else {
      if(path.endsWith(".php")){
        return children;
      }
      return children;
    }
  }

  // Define images directly without useMemo
  const images = [
    homePageImages?.mobileCastle,
    homePageImages?.mobileWindowImg,
    homePageImages?.loveBlossomImg,
    homePageImages?.AdmAwardImg,
    homePageImages?.heartLogoImg,
    homePageImages?.boyChildImg,
    homePageImages?.playImg,
    homePageImages?.boyBoardImg,
    homePageImages?.markerImg,
    homePageImages?.homeImg,
  ];

  return (
    <div>
      <PreLoadingImages images={images} />
      <Header bgColor={bgColor} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/login" element={<Login />} /> */}
        <Route path="/dignitory" element={<Dignitories />} />
        <Route path="/groupsSection" element={<ParticularGroup />} />
        <Route path="/positiveParenting" element={<PositiveParenting />} />
        <Route path="/parentingTips" element={<ParentingTips />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/monthcal" element={<MonthAtAGlance />} />
        <Route path="/celebration" element={<Celebration />} />
        <Route path="/events" element={<Events />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/branch" element={<OurBranch />} />
        <Route path="/thoughtLeadership" element={<ThoughtLeadership />} />
        <Route path="/teachingmethod" element={<TeachingMethod />} />
        <Route path="/interactiveGallery" element={<InteractiveGallery />} />
        <Route path="/curriculumOfLove" element={<CurricumOfLove />} />
        <Route path="/blogs" element={<BlogsAndNews type={"Blogs"} />} />
        <Route path="/news" element={<BlogsAndNews type={"News"} />} />
        <Route path="/blog/:slug/:id" element={<BlogDetail />} />
        <Route path="/StudentProfile" element={ <PrivateRoute> <StudentProfile /> </PrivateRoute>}/>
        <Route path="/getinTouch" element={<GetInTouch />} />
        <Route path="/faq" element={<PrivateRoute><Faq /></PrivateRoute>}/>
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms&Conditions" element={<TermsConditions />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>}/>
        <Route path="/admission" element={<Admission />} />
        <Route path="/mygallery" element={<PrivateRoute><MyGallery /></PrivateRoute>}/>
        <Route path="*" element={<RedirectionRouter><NotFound /></RedirectionRouter>}/>
        {/* <Route path="/management" element={<ManagementTeam />} /> */}
      </Routes>

      {/* <img src={chatIcon} className="custom-icon" alt="Custom Icon" /> */}
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <Provider store={store}>
        <App />
        <ToastContainer />
      </Provider>
    </Router>
  );
}

export default AppWrapper;
